// extracted by mini-css-extract-plugin
module.exports = {"navShim":"flavours-odl-navShim-ef5acc7e","navBurger":"flavours-odl-navBurger-32148877","line":"flavours-odl-line-af7faf16"};